import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@aichat/ui/components/ui/carousel";
import CarouselItemComponent from "./carousel-item-component";
import ButtonComponent from "../buttons/button-component";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import useCarouselApi from "@aichat/ui/hooks/useMainCarouselApi";
import { cn } from "@aichat/ui/lib/utils";
import { CarouselComponent } from "@aichat/types/socket/widget.types";

type CarouselListComponentProps = {
  type?: "portal-chat" | "widget-chat";
  isUser?: boolean;
} & CarouselComponent;

function CarouselListComponent({
  globalButton,
  items,
  isUser,
  type,
}: CarouselListComponentProps) {
  const { setMainCarouselApi, canScrollPrev, canScrollNext, activeIndex } =
    useCarouselApi();

  return (
    <Carousel className="text-center bg-white" setApi={setMainCarouselApi}>
      <CarouselContent
        className={cn("pl-4 mr-4 gap-0", {
          "justify-end": type === "portal-chat" && !isUser,
        })}
      >
        {items.map((item, index) => (
          <CarouselItem
            key={item.id}
            className={cn(
              "basis-[65%] py-6 transition-transform duration-500",
              activeIndex === index ? "scale-100" : "scale-90",
            )}
          >
            <CarouselItemComponent {...item} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <ButtonComponent
        className="shadow-sm rounded-lg text-secondary-foreground px-4"
        payload={globalButton.payload}
        variant="carouselGlobal"
      >
        {globalButton.label} <ArrowRight />
      </ButtonComponent>
      <CarouselPrevious
        icon={<ChevronLeft />}
        className={cn("absolute left-4 shadow bg-white", {
          hidden: !canScrollPrev,
        })}
      />
      <CarouselNext
        icon={<ChevronRight />}
        className={cn("absolute right-4 shadow bg-white", {
          hidden: !canScrollNext,
        })}
      />
    </Carousel>
  );
}

export default CarouselListComponent;
